import { useMemo } from "react";
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer 
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const CHART_BAR_RADIUS = [4, 4, 0, 0];

const TOOLTIP_STYLE = { 
  backgroundColor: "white", 
  border: "1px solid #CBD5E1",
  borderRadius: "6px"
};

export default function MonthlyChart({ monthlyStats }) {
  const tooltipFormatter = useMemo(() => 
    (value) => [`${value.toFixed(2)}€`, "Total"], 
    []
  );

  return (
    <Card className="dashboard-card" data-testid="monthly-chart">
      <CardHeader>
        <CardTitle className="text-lg font-bold text-slate-900">Gastos Mensuales</CardTitle>
      </CardHeader>
      <CardContent>
        {monthlyStats.length === 0 ? (
          <div className="flex items-center justify-center h-64 text-slate-500">
            No hay datos de gastos mensuales
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={monthlyStats}>
              <CartesianGrid strokeDasharray="3 3" stroke="#CBD5E1" />
              <XAxis dataKey="mes" stroke="#0F172A" fontSize={12} />
              <YAxis stroke="#0F172A" fontSize={12} />
              <Tooltip 
                contentStyle={TOOLTIP_STYLE}
                formatter={tooltipFormatter}
              />
              <Bar dataKey="total" fill="#0F172A" radius={CHART_BAR_RADIUS} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
